import FooterSetup from '@/features/design-system/components/common/FooterSetup'
import { useUnits } from '@/hooks/useUnits'
import { DATA_PAGINATION, Plant } from '@/types'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface PlantTableProps {
  data?: DATA_PAGINATION<Plant>
}

const PlantTable: FC<PlantTableProps> = ({ data }) => {
  const { convertLabelUnit, convertFromMetric } = useUnits()

  return (
    <Stack flexGrow="1" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  boxShadow: 'inset -1px 0px 0px #D7D7D7',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Allowable Depletion (%)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Refill to (%)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Root Zone ({convertLabelUnit('mm')})
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Plant Factor (%)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                ET Reference
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data?.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ position: 'sticky', left: 0 }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    width: '182px',
                    boxShadow: 'inset -1px 0px 0px #D7D7D7',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  {row.description}
                </TableCell>
                <TableCell>{row.allowableDepletion}</TableCell>
                <TableCell>{row.refillTo}</TableCell>
                <TableCell>{convertFromMetric(row.rootZone, 'mm')}</TableCell>
                <TableCell>{row.factor}</TableCell>
                <TableCell
                  sx={{
                    width: '217px',
                  }}
                >
                  {row.etReference.description || ''}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack mt="20px">
        <FooterSetup
          title={`${data?.totalCount || 0} rows of data detected`}
          subtitle="Review the data before proceeding"
        />
      </Stack>
    </Stack>
  )
}

export default PlantTable
